import './style.less'
import 'bui/styles/colors-material.less'

import 'bui/app/error-handler'

import 'bui/helpers/day-js'
import 'bui/helpers/lit'
import 'bui/helpers/lit/shared'
import 'bui/helpers/lit/listeners'
import 'bui/helpers/lit/model'
import 'bui/elements/btn'
import 'bui/elements/hr'
import 'bui/elements/paper'
import 'bui/elements/text'
import 'bui/elements/grid'
import 'bui/elements/flex'
import 'bui/elements/label'
import 'bui/elements/ribbon'
import 'bui/presenters/form/handler'
import 'bui/presenters/form/control'
import 'bui/presenters/form/controls/text-field'
import 'bui/presenters/form/controls/select-field'
import 'bui/presenters/form/controls/radio-group'
import 'bui/presenters/form/controls/radio-btn'
import IconElement from 'bui/elements/icon'

IconElement.register(
	require('bui/elements/icon/legacy/cancel-1.svg.html'),
	require('bui/elements/icon/legacy/calendar-3.svg.html'),
	require('bui/elements/icon/legacy/ok-circled.svg.html'),
	require('bui/elements/icon/legacy/alert.svg.html'),
	require('bui/elements/icon/legacy/attention-1.svg.html'),
	require('bui/elements/icon/legacy/attention-circle.svg.html'),
	['check-box', require('bui/elements/icon/legacy/check-box.svg.html')],
	['check-box-active', require('bui/elements/icon/legacy/check-box-active.svg.html')],
	['pencil', require('@material-icons/svg/svg/edit/baseline.svg')],
	['close', require('@material-icons/svg/svg/close/baseline.svg')],

	['warning', require('@material-icons/svg/svg/warning/baseline.svg')]
)
